import { useLayoutEffect } from "react";

export type Theme = "light";

export function useTheme(): { theme: Theme; toggleTheme: () => void } {
  useLayoutEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);
  return { theme: "light", toggleTheme: () => {} };
}
